import sdl from '@jds/react-generated-sdl/JDSFooterLinks';
import type { JDSFooterLinksProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSFooterLinksProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { custom = '', ...rest } = props as any;
  return createComponent(
    json,
    rest,
    'JDSFooterLinks',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const FooterLinks = withLogic(Component) as React.FC<JDSFooterLinksProps> & {
  slotName?: string;
};

FooterLinks.displayName = 'FooterLinks';
FooterLinks.slotName = 'jds_footer_links';

export { FooterLinks, type JDSFooterLinksProps };
